import { addDays, todayStr } from '@/lib/dates'

/**
 * Web mirror of the app's `constants/history.ts` `isDayLocked`: a free user can
 * open today plus the previous `FREE_HISTORY_DAYS` days; older days are locked.
 * Pro never locks. Date keys are `YYYY-MM-DD`, so string order is date order.
 */
export const FREE_HISTORY_DAYS = 7

export function isDayKeyLocked(dateKey: string, isPremium: boolean, today: string = todayStr()): boolean {
  if (isPremium) return false
  return dateKey < addDays(today, -FREE_HISTORY_DAYS)
}
